import Link from 'next/link';
import pluralize from 'pluralize';

import { AlertModalDescription } from '@air/primitive-alert-modal';

import { type DeletePrivateClipsResult } from '~/swr-hooks/clips/useDeletePrivateClips';

type DeleteAssetMessageModalDescriptionProps = Pick<DeletePrivateClipsResult, 'ignoredAssetIds' | 'removedAssetIds'>;

export const DeleteAssetMessageModalDescription = ({
  ignoredAssetIds,
  removedAssetIds,
}: DeleteAssetMessageModalDescriptionProps) => {
  return (
    <AlertModalDescription className="pt-1 pb-2">
      <p className="text-14">
        {ignoredAssetIds.length
          ? `You don't have the necessary permissions to delete ${pluralize(
              'this',
              ignoredAssetIds.length,
            )} ${pluralize('asset', ignoredAssetIds.length)} in all of ${pluralize(
              'its',
              ignoredAssetIds.length,
            )} locations.`
          : `Since you don't have the necessary permissions to delete ${pluralize(
              'this',
              removedAssetIds.length,
            )} ${pluralize('asset', removedAssetIds.length)} in all of ${pluralize(
              'its',
              removedAssetIds.length,
            )} locations, ${pluralize('this', removedAssetIds.length)} ${pluralize(
              'asset',
              removedAssetIds.length,
            )} ${pluralize('was', removedAssetIds.length)} removed from board(s) instead.`}
        <Link
          target="_blank"
          className="px-3 font-bold text-14 text-blue-11"
          href="https://help.air.inc/en/articles/8584302-deleting-content"
        >
          Learn more
        </Link>
      </p>
    </AlertModalDescription>
  );
};
